import { put, call } from 'redux-saga/effects';
import endpoint from "../../const/backend";
const axios = require('axios');

function apiAdd(body){
    return body.addVoucher({
        variables:{ 
            beginDate: body.voucher.beginDate.format().toString(),
            endDate: body.voucher.endDate.format().toString(),
            room: body.voucher.room,
            client: body.voucher.client
        }
    })
}
  
export function* addVoucher(action){
    try{
        const response = yield call(apiAdd, action.body);
        yield put({ type: "SUCCESS_ADD_VOUCHER", payload: { data: response } });
    }catch(err){
        yield put({ type: "FAILURE_ADD_VOUCHER" })
    }
}

function apiUpdate(body){
    return body.updateVoucher({
        variables:{ 
            _id: body.voucher._id, 
            beginDate: body.voucher.beginDate,
            endDate: body.voucher.endDate,
            room: body.voucher.room,
            client: body.voucher.client
        }
    });
}

export function* updateVoucher(action){
    try{
        const response = yield call(apiUpdate, action.body);
        yield put({ type: "SUCCESS_UPDATE_VOUCHER", payload: { data: response } });
    }catch(err){
        yield put({ type: "FAILURE_UPDATE_VOUCHER" })
    }
}

function apiRemove(body){
    return body.removeVoucher({
        variables:{ 
            _id: body._id
        }
    });
}

export function* removeVoucher(action){
    try{
        const response = yield call(apiRemove, action.body);
        yield put({ type: "SUCCESS_REMOVE_VOUCHER", payload: { data: response } });
    }catch(err){
        yield put({ type: "FAILURE_REMOVE_VOUCHER" })
    }
}

function apiCheck(body){
    return axios.post(endpoint+"/voucher", body , 
        {
        headers: {
            'Content-Type': 'application/json',
        }
    });
}
  
export function* checkVoucher(action){
    try{
        const response = yield call(apiCheck, action.body);
        yield put({ type: "SUCCESS_CHECK_VOUCHER", payload: { data: response } });
    }catch(err){
        yield put({ type: "FAILURE_CHECK_VOUCHER" })
    }
}

function apiVouchers(body){
    return axios.post(endpoint+"/voucher/vouchers", body , 
        { headers: { 'Content-Type': 'application/json'}
    });
}
  
export function* getVouchers(action){
    try{
        const response = yield call(apiVouchers, action.body);
        yield put({ type: "SUCCESS_GET_VOUCHERS", payload: { data: response } });
    }catch(err){
        yield put({ type: "FAILURE_GET_VOUCHERS" })
    }
}


// WEBPACK FOOTER //
// ./src/store/sagas/voucher.js